import Admin from "../../views/admin/Index.vue";

const AdminRoute = [
  {
    path: "/admin",
    name: "Admin",
    component: Admin,
  },
];

export default AdminRoute;
